import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { Router } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'dashboard-data-dialog',
    templateUrl: './dashboard-data-dialog.component.html',
    styleUrls: ['./dashboard-data-dialog.component.scss'],
    standalone: false
})

export class DashboardDataDialogComponent {
  type;
  menuData;
  title;
  app: any = {};

  constructor(
    public dialogRef: MatDialogRef<DashboardDataDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService, public ms: MessengerService,
    private router: Router
  ) {
    if (data) {
      this.type = data.type;
      if (data.app) {
        this.app = {app: data.app};
      }
      this.menuData = data.menuData.map(el => {
        if (el.path !== 'dashboard') {
          el.navigateTo = el.subRoutes.find(sr => this.type === 'content' ? sr.path === 'dynamic-content' : sr.path === 'navigation');
          return el;
        }
      }).filter(el => el);
      const key = this.type === 'content' ? 'dashboard.chooseContent' : 'dashboard.chooseConfiguration';
      if (this.type === 'navigation') {
        this.menuData = this.menuData.filter(m => !!this.isValid(m, this.app?.app));
      }
      if (this.menuData?.length === 1) {
        this.navigateToSubPage(this.menuData?.[0]?.navigateTo, this.menuData?.[0]?.data?.title);
      }
      this.title = this.translate.get(key);
    }
  }

  navigateToSubPage(route, mainDataTitle) {
    const commands = [{ outlets: { primary: [route?.path], org: this.ms.getOrganisation().name } }];
    if (route?.data?.packageId) {
      commands[0].outlets.primary.push(route.data.packageId);
    }
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(commands, {queryParams: this.app}));
    route.mainDataTitle = mainDataTitle;
    this.ms.setPackageConfiguration(route?.metaConfig);
    this.ms.setRouteFromDashboard(route);
    this.dialogRef.close();
  }

  isValid(item, app: string) {
    const field = app.includes('Tablet') ? 'tablet' : (app.includes('Mobile') ? 'smart' : app.includes('TV') ? 'tv' : 'touch');
    return item?.data?.['isIbex' + field];
  }
}
